<template>
  <div>
    <span class="font-size-15 font-weight-bold d-block mb-3">
      Основна інформація
    </span>
    <v-row>
      <v-col cols="12" md="6">
        <b-input
          v-model="journalCredentials.code"
          :error-messages="getErrorMessages(v$.code)"
          hide-details
          label="Код журналу"
          @blur="v$.code.$touch()" />
      </v-col>
      <v-col cols="12" md="6">
        <b-input
          v-model="journalCredentials.name"
          :error-messages="getErrorMessages(v$.name)"
          hide-details
          label="Назва журналу"
          @blur="v$.name.$touch()" />
      </v-col>
    </v-row>
    <v-divider class="mt-5 mb-4"></v-divider>
    <journal-mask></journal-mask>
  </div>
</template>

<script lang="ts">
import { useRegistrationJournal } from '../registrationJournal'
import { getErrorMessages } from 'best-modules/utils'
import JournalMask from '../components/JournalMask.vue'

export default {
  name: 'RegistrationJournalGeneralInfo',
  components: { JournalMask },
  methods: { getErrorMessages },
  setup() {
    const { journalCredentials, journalSource, v$ } = useRegistrationJournal()

    return {
      journalCredentials,
      journalSource,
      v$,
    }
  },
}
</script>

<style lang="scss" scoped></style>
